
<div id="privacy-policy" class="policy-container">
	<div class="center-wrapper">
		<h4>Privacy Policy</h4>
	</div>
	<div class="policy-block">
				This policy covers how Jailhouse Mail, LLC (“Jailhouse Mail”) treats information and data that Jailhouse Mail collects
		and receives about, from or in connection with you (collectively, “Information”), including, without limitation, all
		information and content transmitted through your use of the website and services of Jailhouse Mail (the “Services”)
		and including personal information. Personal information is information about you that is personally identifiable like
		your name, address, email address, or phone number, and that is not otherwise publicly available.
		This policy does not apply to the practices of entities that Jailhouse Mail does not own or control, or to people that
		Jailhouse Mail does not employ or manage.
	</div>
	<div class="policy-block">
		Your Information may be transferred to countries other than your own to process and store data in accordance with
		this Privacy Policy and to provide you with products and services. Some of these countries may not have the same
		data protection safeguards as the country where you reside. By using the Services, you consent to Jailhouse Mail
		transferring your data to these countries. Jailhouse Mail is committed to ensuring your information is protected and
		applies safeguards in accordance with applicable law.
	</div>
	<div class="policy-block">
		Your use of the Services is not anonymous. You have no expectation of privacy and Jailhouse Mail will disclose
		Information to operators of correctional facilities and to governmental authorities (“Law Enforcement
		Officials”).
	</div>
	<div class="policy-block">
		Jailhouse Mail collects Information when you register with Jailhouse Mail (including information such as your name,
		email address, birth date, gender, address, occupation, and Social Security Number) and when you use or access the
		Services. Jailhouse Mail collects information about your transactions with Jailhouse Mail and with third parties
		engaged by Jailhouse Mail to provide data center, hosting, infrastructure or other services, equipment, or software
		(“Third Parties”) and information about your use of the Services. Jailhouse Mail automatically receives and records
		information from your computer and browser when you access the Services, including your IP Address, information
		from cookies, software and hardware attributes, and the page you request. IP Addresses can be used to identify the
		location of the computer or other device from which you are accessing services. Cookies are small text files that are
		placed on your computer by websites and services that you visit or access. Jailhouse Mail uses cookies to make its
		websites and services work and function with greater efficiency, and to provide information about Jailhouse Mail’s
		users’ experience during use of, or interaction with, its websites, the Services and advertisements. Some cookies last
		only for the duration of your web session and expire when you exit your browser; other cookies may last for longer
		than your web session, including after you exit your browser, for example by remembering you when you return to
		the Jailhouse Mail website.
	</div>
	<div class="policy-block">
		Jailhouse Mail may combine Information that it obtains from you or from your use of the Services with information
		it obtains about other persons or entities (“Aggregated Information”).
	</div>
	<div class="policy-block">
		Jailhouse Mail uses Information and Aggregated Information for the following general purposes: to fulfill your
		requests for Services, improve the Services, contact you, conduct research, provide anonymous reporting for internal
		and external clients, and to provide both Information and Aggregated Information to Law Enforcement Officials.
		Jailhouse Mail does not rent, sell, or share personal information about you with other people or non-affiliated
		companies except to provide Services you've requested, when we have your permission, or under the following
		circumstances:
	</div>
	<div class="policy-points">
		<div class="point">
			• Jailhouse Mail will provide Information and Aggregated Information to Law Enforcement Officials
			and to Third Parties under confidentiality agreements. These entities may use such information, including
			without limitation, your personal information, for law enforcement purposes and in performance of services
			for Jailhouse Mail. However, these companies do not have any independent right to share Information except
			that Law Enforcement Officials may provide the Information to other Law Enforcement Officials.
		</div>
		<div class="point">
			• Jailhouse Mail may share Information and Aggregated Information to respond to subpoenas, court orders, or
			legal process, or to establish or exercise its legal rights or defend against legal claims.
		</div>
		<div class="point">
			• Jailhouse Mail may share Information and Aggregated Information in order to investigate, prevent, or take
			action regarding illegal activities, suspected fraud, situations involving potential threats to the physical safety
			of any person, violations of Jailhouse Mail's terms of use, or as otherwise required by law.
		</div>
		<div class="point">
			• Jailhouse Mail will transfer Information and Aggregated Information if Jailhouse Mail is acquired by or
			merged with another company.
		</div>
		<div class="point">
			• Jailhouse Mail may share your Information and Aggregated Information with Third Parties, or otherwise use
			your Information and Aggregated Information, to provide targeted advertisements. If you interact with, view,
			or click targeted advertisements, the advertisers may assume you meet certain criteria.
			Jailhouse Mail may update this policy. Jailhouse Mail will notify you about significant changes in the way it treats
			personal information by sending a notice to the primary email address specified in your Jailhouse Mail account or by
			placing a notice on Jailhouse Mail’s website.
		</div>
	</div>
	<div class="center-wrapper">
		<div class="logo-and-name">
		  <img class="logo" src="./assets/images/bird.svg">
		  <div class="name">
			<img class="jail" src="./assets/images/jail.svg">
			<img class="house" src="./assets/images/house.svg">
			<img class="mail" src="./assets/images/mail.svg">
		  </div>
		</div>
	</div>
</div>